export default "__VITE_PUBLIC_ASSET__ed96017a__"